// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__189K1","menu__item":"styles_menu__item__3_Ego","active":"styles_active__nxXQs","break":"styles_break__2W0fA"};